// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `Submitting...`
};

const de_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `Wird übermittelt...`
};

const es_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `Enviando...`
};

const fr_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `Soumission en cours...`
};

const fi_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `Lähetetään...`
};

const hi_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `जमा कर रहे हैं...`
};

const ja_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `送信中...`
};

const nl_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `Bezig met verzenden...`
};

const pt_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `Enviando...`
};

const ro_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `Se trimite...`
};

const th_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `กำลังส่ง...`
};

const ur_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `جمع کرا رہا ہے...`
};

const zh_hant1_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `提交中...`
};

const da_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `Sender...`
};

const it_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `Invio in corso...`
};

const vn_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `Đang gửi...`
};

const ko_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `제출 중...`
};

const tr_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `Gönderiliyor...`
};

const lv_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `Iesūta...`
};

const ar_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `جاري الإرسال...`
};

const bs_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `Šalje se...`
};

const sl_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `Pošiljanje...`
};

const id_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `Mengirim...`
};

const sv_widget_login_submitting = /** @type {(inputs: {}) => string} */ () => {
	return `Skickar...`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_login_submitting = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_login_submitting(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_login_submitting", locale)
	if (locale === "en") return en_widget_login_submitting(inputs)
	if (locale === "de") return de_widget_login_submitting(inputs)
	if (locale === "es") return es_widget_login_submitting(inputs)
	if (locale === "fr") return fr_widget_login_submitting(inputs)
	if (locale === "fi") return fi_widget_login_submitting(inputs)
	if (locale === "hi") return hi_widget_login_submitting(inputs)
	if (locale === "ja") return ja_widget_login_submitting(inputs)
	if (locale === "nl") return nl_widget_login_submitting(inputs)
	if (locale === "pt") return pt_widget_login_submitting(inputs)
	if (locale === "ro") return ro_widget_login_submitting(inputs)
	if (locale === "th") return th_widget_login_submitting(inputs)
	if (locale === "ur") return ur_widget_login_submitting(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_login_submitting(inputs)
	if (locale === "da") return da_widget_login_submitting(inputs)
	if (locale === "it") return it_widget_login_submitting(inputs)
	if (locale === "vn") return vn_widget_login_submitting(inputs)
	if (locale === "ko") return ko_widget_login_submitting(inputs)
	if (locale === "tr") return tr_widget_login_submitting(inputs)
	if (locale === "lv") return lv_widget_login_submitting(inputs)
	if (locale === "ar") return ar_widget_login_submitting(inputs)
	if (locale === "bs") return bs_widget_login_submitting(inputs)
	if (locale === "sl") return sl_widget_login_submitting(inputs)
	if (locale === "id") return id_widget_login_submitting(inputs)
	if (locale === "sv") return sv_widget_login_submitting(inputs)
	return "widget_login_submitting"
};